/**
 * Canonical role system: single source of truth for DB enum user_role.
 * UI labels are display-only; all API/DB usage must use these values.
 *
 * DB enum (Supabase): customer | tradie | admin | property_manager
 */

export const USER_ROLES = ['customer', 'tradie', 'admin', 'property_manager', 'tenant'] as const;
export type UserRole = (typeof USER_ROLES)[number];

/** Display labels for UI only. DB/API always use USER_ROLES values. */
export const ROLE_LABELS: Record<UserRole, string> = {
  customer: 'Customer',
  tradie: 'Tradie',
  admin: 'Admin',
  property_manager: 'Real Estate Agent',
  tenant: 'Tenant',
};

const ROLE_SET = new Set<string>(USER_ROLES);

/**
 * Parse and validate role from URL search param (e.g. ?role=...).
 * Invalid or unknown values (e.g. "real_estate_agent") return defaultRole.
 */
export function parseRoleFromSearchParam(
  param: string | null,
  defaultRole: UserRole = 'property_manager'
): UserRole {
  if (param == null || param === '') return defaultRole;
  const normalized = param.trim().toLowerCase();
  return ROLE_SET.has(normalized) ? (normalized as UserRole) : defaultRole;
}

export function isUserRole(value: string): value is UserRole {
  return ROLE_SET.has(value);
}
